module.exports = "/images/modal-close.png?bf4121ef3f899f38dd427cbff587db1a";